import { API } from '../../utils';
import { IParams } from '../types';
import { GW_SERVICES_PREFIXES } from '../../constants';

const { C300 } = GW_SERVICES_PREFIXES;

/* Запрос дерева ФИАС */
export const GetTree = () => API.get(`/${C300}/fias/get_tree/`);

/* Запрос групп домов */
export const GetHouseGroups = () => API.get(`/${C300}/models/house_groups/`);

/* Запрос количества квартир */
export const GetFlatCount = (id: string) =>
  API.get(`/${C300}/models/house_area_count/`, undefined, id);

/* Запрос искомых адресов */
export const GetSearchTree = (params: IParams) =>
  API.get(`/${C300}/fias/search_tree/`, undefined, params);

/* Запрос дерева ФИАС с направлениями(sectors) по которым создаются начисления (В Документообороте вместо GetTreeWithAllSectors)*/
export const GetTreeWithSectors = () =>
  API.get(`/${C300}/tree/c_accruals_sectors/`);

/* Запрос дерева ФИАС со всеми направлениями(sectors) */
//TODO: пока что нигде не используется
export const GetTreeWithAllSectors = () =>
  API.get(`/${C300}/fias/get_tree_with_sectors/`);

/* Запрос групп домов с направлениями(sectors) */
export const GetHouseGroupsWithSectors = () =>
  API.get(`/${C300}/models/house_groups_with_sectors/`);

/* Запрос искомых адресов с направлениями(sectors) */
export const GetSearchTreeWithSectors = (params: IParams) =>
  API.get(`/${C300}/fias/search_tree_with_sectors/`, undefined, params);
